import React from 'react';
import Modal from 'react-bootstrap/Modal';

export const HandoverDates = ({
	show,
	onCloseHandoverDates,
	onUpdateEtd,
	onChangeUpdateEtd,
	onRemoveFactory,
	canRemoveFactory,
	supplierName,
	isLoading,
	errors = null,
	editFactoryEtd,
	factoryDeliveryDate,
	factoryHandoverDate
}) => {
	const assignedFactoryName = editFactoryEtd?.supplierName || supplierName;

	return (
		<>
			<Modal show={show} onhide={onCloseHandoverDates} backdrop="static" centered>
				<div className="">
					<Modal.Header closebutton>
						<h3 className="semibold-16 mb-0 ml-3">Handover &amp; factory date</h3>
					</Modal.Header>
					<Modal.Body>
						<div className="common-popup-body">
							<div className="container px-0">
								<div className="row">
									<div className="col-md-12">
										{assignedFactoryName && (
											<div className="col-md-12">
												<div className="form-group">
													<label htmlFor="assignedFactory">Factory</label>
													<div className="d-flex align-items-center justify-content-between">
														<span
															id="assignedFactory"
															className="regular-14 gray_dark_01"
														>
															{assignedFactoryName}
														</span>
														{canRemoveFactory && (
															<span
																className="red regular-14 cursor-pointer"
																onClick={onRemoveFactory}
															>
																Remove
															</span>
														)}
													</div>
													{canRemoveFactory && (
														<p className="regular-12 gray_dark_02 mb-0 mt-1">
															Removing the factory moves this purchase order to
															a separate style so another factory can be
															assigned to it.
														</p>
													)}
												</div>
											</div>
										)}

										<div className="col-md-12">
											<div className="form-group ">
												<label htmlFor="b-title">
													Handover to factory (mm/dd/yyyy)
												</label>
												<input
													type="date"
													min={editFactoryEtd?.factoryHandoverDate || null}
													max={editFactoryEtd?.factoryDeliveryDate || null}
													value={
														factoryHandoverDate ||
														editFactoryEtd?.factoryHandoverDate
													}
													onChange={(e) =>
														onChangeUpdateEtd(e, 'factoryHandoverDate')
													}
												/>
												{errors?.includes('HANDOVER_ERROR') && (
													<p className="error">Handover date is required</p>
												)}
											</div>
										</div>

										<div className="col-md-12">
											<div className="form-group ">
												<label htmlFor="acname">Factory ETD (mm/dd/yyyy)</label>
												<input
													type="date"
													max={editFactoryEtd?.deliveryDate || null}
													value={
														factoryDeliveryDate ||
														editFactoryEtd?.factoryDeliveryDate
													}
													onChange={(e) =>
														onChangeUpdateEtd(e, 'factoryDeliveryDate')
													}
												/>
												{errors?.includes('DELIVERY_ERROR') && (
													<p className="error">Delivery date is required</p>
												)}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</Modal.Body>
				</div>
				<Modal.Footer>
					<div className="footer-buttons text-right mr-3">
						<button className="button outline size32" onClick={onCloseHandoverDates}>
							Cancel
						</button>
						<button className="button size32 ml-2" disabled={isLoading} onClick={onUpdateEtd}>
							Submit
						</button>
					</div>
				</Modal.Footer>
			</Modal>
		</>
	);
};
